export const NAME = 'add-panels-modal';
